import { render } from "./commonComponent.vue?vue&type=template&id=48bf4724&scoped=true"
import script from "./commonComponent.vue?vue&type=script&lang=js"
export * from "./commonComponent.vue?vue&type=script&lang=js"

import "./commonComponent.vue?vue&type=style&index=0&id=48bf4724&scoped=true&lang=css"

import exportComponent from "F:\\CS\\Projectsdatabases\\madienty-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bf4724"]])

export default __exports__